import { DefaultFilenameTemplateItemType, FilenameTemplateItem } from '../..'
import { FilenameTemplateItemCompatible } from '../filenameTemplateItems/classes/FilenameTemplateItemCompatible'
import { PhotoSequenceNumber } from '../filenameTemplateItems/instances/classless'

const Prefix = {
  AsphaltLot: 'ASPHALT-LOT',
  AsphaltPlacement: 'ASPHALT-PLACEMENT',
  ConcreteTestSet: 'CONCRETE-TEST-SET',
  DailyInspectionControlPoint: 'CONTROL-POINT',
  DailyInspectionInspection: 'INSPECTION',
  DailyInspectionPunchList: 'PUNCH-LIST',
  Lot: 'LOT',
} as const

export class PhotoExportClassTypeItem<
  ID extends string,
  ClassType extends keyof typeof Prefix
> extends FilenameTemplateItemCompatible<ID> {
  /**
   * the prefix to be used in the default template items
   */
  prefix: (typeof Prefix)[ClassType]
  /**
   * the template item to use as the identifier in the default template items
   */
  identifier: FilenameTemplateItem
  /**
   * how the name of the class should be displayed in the UI
   */
  classTypeName: string
  /**
   * the name of the class associated with the media upload
   */
  classType: ClassType
  /**
   * @see {@link FilenameTemplateItemCompatible}
   */
  constructor({
    id,
    classType,
    classTypeName,
    compatibleTemplateItems,
    identifier,
  }: Pick<
    PhotoExportClassTypeItem<ID, ClassType>,
    | 'id'
    | 'classType'
    | 'classTypeName'
    | 'compatibleTemplateItems'
    | 'identifier'
  >) {
    super({
      id,
      compatibleTemplateItems: [
        ...compatibleTemplateItems,
        PhotoSequenceNumber,
      ],
    })
    this.classType = classType
    this.classTypeName = classTypeName
    this.prefix = Prefix[classType]
    this.identifier = identifier
  }

  /**
   * @see {@link DefaultFilenameTemplateItemType}
   * @see {@link prefix}
   * @see {@link identifier}
   */
  get defaultTemplateItems(): DefaultFilenameTemplateItemType[] {
    return [
      { type: 'custom', text: this.prefix },
      { type: 'custom', text: '_' },
      { type: 'templateItem', templateItemId: this.identifier.id },
      { type: 'custom', text: '_' },
      { type: 'templateItem', templateItemId: PhotoSequenceNumber.id },
    ]
  }
}
